import { defineMessages } from 'react-intl'

export default defineMessages({
  link: {
    id: 'containers.CustomerVoiceSelectorsPage.link',
    defaultMessage: 'Link',
  },
  title: {
    id: 'containers.CustomerVoiceSelectorsPage.title',
    defaultMessage: 'Title',
  },
  date: {
    id: 'containers.CustomerVoiceSelectorsPage.date',
    defaultMessage: 'Date',
  },
  creator: {
    id: 'containers.CustomerVoiceSelectorsPage.creator',
    defaultMessage: 'Created by',
  },
  noResults: {
    id: 'containers.CustomerVoiceSelectorsPage.noResults',
    defaultMessage: 'Reach out to us to receive a custom VoiceSelector for your next project.',
  },
})
